import writingLoginCardBanner from '@images/logos/writing-login-card-banner.png'
import mathsLoginCardBanner from '@images/logos/maths-login-card-banner.png'
import mathsLoginCardBannerAuBlack from '@images/logos/maths-login-card-banner-au-black.png'
import readingLoginCardBannerBlack from '@images/logos/reading-login-card-banner-black.png'
import readingLoginCardBannerAuBlack from '@images/logos/reading-login-card-banner-au-black.png'
import Component from '@glimmer/component'
import { service } from '@ember/service'
import type SessionService from 'teacher-ui-client/services/session'
import { SubscriptionType } from 'teacher-ui-client/subscription-type/subscription-types'
import { t } from 'ember-intl'

interface Signature {
  Args: {
    Named: {
      subscriptionType: SubscriptionType
    }
  }
}

export class LoginCardLogos extends Component<Signature> {
  @service session!: SessionService

  get useAuLogos() {
    return this.session.currentSchool.countryCode === 'AU'
  }

  get readingLogoBannerSrc() {
    return this.useAuLogos ? readingLoginCardBannerAuBlack : readingLoginCardBannerBlack
  }

  get mathsLogoBannerSrc() {
    return this.useAuLogos ? mathsLoginCardBannerAuBlack : mathsLoginCardBanner
  }

  get writingLogoBannerSrc() {
    return writingLoginCardBanner
  }

  get logoBannerSrc() {
    switch (this.args.subscriptionType) {
      case SubscriptionType.Reading:
        return this.readingLogoBannerSrc
      case SubscriptionType.Maths:
        return this.mathsLogoBannerSrc
      case SubscriptionType.Writing:
        return this.writingLogoBannerSrc
      default:
        return ''
    }
  }

  <template>
    <div data-test-card-logos class="flex justify-center gap-2">
      <img
        data-test-card-logo={{@subscriptionType}}
        src={{this.logoBannerSrc}}
        class="shrink"
        alt={{t @subscriptionType}}
      />
    </div>
  </template>
}
